import {
    CREATE_COLOR_DETAIL_FAILURE,
    CREATE_COLOR_DETAIL_REQUEST,
    CREATE_COLOR_DETAIL_SUCCESS,
    CREATE_USER_FORM_COLOR_DETAIL,
    DELETE_COLOR_DETAIL_FAILURE,
    DELETE_COLOR_DETAIL_REQUEST,
    DELETE_COLOR_DETAIL_SUCCESS,
    FETCH_COLOR_DETAIL_FAILURE,
    FETCH_COLOR_DETAIL_REQUEST,
    FETCH_COLOR_DETAIL_SUCCESS,
    FETCH_COLOR_DETAIL_WITHOUT_ID_FAILURE,
    FETCH_COLOR_DETAIL_WITHOUT_ID_FAILURE1,
    FETCH_COLOR_DETAIL_WITHOUT_ID_REQUEST,
    FETCH_COLOR_DETAIL_WITHOUT_ID_REQUEST1,
    FETCH_COLOR_DETAIL_WITHOUT_ID_SUCCESS,
    FETCH_COLOR_DETAIL_WITHOUT_ID_SUCCESS1,
    FETCH_COLOR_DETAIL_WITH_ID_FAILURE,
    FETCH_COLOR_DETAIL_WITH_ID_REQUEST,
    FETCH_COLOR_DETAIL_WITH_ID_SUCCESS,
    FETCH_COLOR_SHADE_DYEING_FAILURE,
    FETCH_COLOR_SHADE_DYEING_REQUEST,
    FETCH_COLOR_SHADE_DYEING_SUCCESS,
    FETCH_SINGLE_COLOR_DETAIL_FAILURE,
    FETCH_SINGLE_COLOR_DETAIL_REQUEST,
    FETCH_SINGLE_COLOR_DETAIL_SUCCESS,
    RESET_USER_FORM_COLOR_DETAIL,
    UPDATE_COLOR_DETAIL_FAILURE,
    UPDATE_COLOR_DETAIL_REQUEST,
    UPDATE_COLOR_DETAIL_SUCCESS
} from './colorDetails.actionsType';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';

export let fetchColorDetail = (id) => {
    // GetColourDetail
};
// FETCH COLOR DETAILS
export let fetchColorDetailsById = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.colorDetailsGET_BY_ID}/${id}`,
        responseTypeRequest: FETCH_COLOR_DETAIL_REQUEST,
        responseTypeSuccess: FETCH_COLOR_DETAIL_SUCCESS,
        responseTypeFailure: FETCH_COLOR_DETAIL_FAILURE
    };
    return axiosCall(config);
};

// FETCH COLOR DETAILS
export let fetchColorDetailsWithoutId = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.colorDetailsGET}`,
        responseTypeRequest: FETCH_COLOR_DETAIL_WITHOUT_ID_REQUEST,
        responseTypeSuccess: FETCH_COLOR_DETAIL_WITHOUT_ID_SUCCESS,
        responseTypeFailure: FETCH_COLOR_DETAIL_WITHOUT_ID_FAILURE
    };
    return axiosCall(config);
};

export let fetchColorDetailsWithId = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.colorDetailsGET}/${id}`,
        responseTypeRequest: FETCH_COLOR_DETAIL_WITH_ID_REQUEST,
        responseTypeSuccess: FETCH_COLOR_DETAIL_WITH_ID_SUCCESS,
        responseTypeFailure: FETCH_COLOR_DETAIL_WITH_ID_FAILURE
    };
    return axiosCall(config);
};


export let fetchColorShadeDyeing = (FldFKStyle, ProgramId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.colorListStyleShade}?FldFKStyle=${FldFKStyle}&FldFKProgramId=${ProgramId}`,
        responseTypeRequest: FETCH_COLOR_SHADE_DYEING_REQUEST,
        responseTypeSuccess: FETCH_COLOR_SHADE_DYEING_SUCCESS,
        responseTypeFailure: FETCH_COLOR_SHADE_DYEING_FAILURE
    };
    return axiosCall(config);
};

// create color detail Form
export let createColorDetailsUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_COLOR_DETAIL, payload: { key, value } });
    };
};

// CREATE COLOR DETAIL
export let createColorDetails = (userform, modalClose) => {
    console.log('userform action>>>>>>>>>>>>', userform);
    let { parentColorId, description, CShade, ColMixInfo, pantoneCode } = userform;
    let today = new Date();
    let data = JSON.stringify({
        fldFKColour: parseInt(parentColorId),
        fldShadeCode: CShade,
        fldDescription: description?.description || '',
        fldPantoneCode: pantoneCode,
        fldColorMixingInfo: ColMixInfo,
        fldIsActive: true,
        fldEnteredSysId: userform.ipv4,
        fldCreatedBy: 0,
        fldCreatedDt: today.toISOString()
    });
    console.log('data :>> ', data);
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.colorDetailsPOST}?sColorDtlCode=${userform?.description?.sDes || ''}`,
        responseTypeRequest: CREATE_COLOR_DETAIL_REQUEST,
        responseTypeSuccess: CREATE_COLOR_DETAIL_SUCCESS,
        responseTypeFailure: CREATE_COLOR_DETAIL_FAILURE,
        resetFormData: RESET_USER_FORM_COLOR_DETAIL,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchColorDetailsById(parentColorId)
    };
    return axiosCall(config);
};

// GET SINGLE Color Details
export let getSingleColorDetails = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.colorDetailsGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_COLOR_DETAIL_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_COLOR_DETAIL_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_COLOR_DETAIL_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateColorDetails = (id, formData) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldSINo: parseInt(formData.slNo),
        fldColorCode: formData.fldColorCode,
        fldFKColour: parseInt(formData.parentColorId), //color mas id
        fldDescription: formData.description || '',
        fldColourCode: formData.code,
        fldColorMixingInfo: formData.ColMixInfo,
        fldShadeCode: formData.CShade,
        fldPantoneCode: formData.pantoneCode,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString()
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.colorDetailsPATCH}/${id}`,
        responseTypeRequest: UPDATE_COLOR_DETAIL_REQUEST,
        responseTypeSuccess: UPDATE_COLOR_DETAIL_SUCCESS,
        responseTypeFailure: UPDATE_COLOR_DETAIL_FAILURE,
        resetFormData: RESET_USER_FORM_COLOR_DETAIL,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchColorDetailsById(formData.parentColorId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteColorDetail = (id, colorId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.colorDetailsDELETE}/${id}`,
        responseTypeRequest: DELETE_COLOR_DETAIL_REQUEST,
        responseTypeSuccess: DELETE_COLOR_DETAIL_SUCCESS,
        responseTypeFailure: DELETE_COLOR_DETAIL_FAILURE,
        modalClose: true,
        getAllData: fetchColorDetailsById(colorId)
    };
    return axiosCall(config);
};

export let fetchColorDetailsWithoutId1 = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.colorDetailsGET1}`,
        responseTypeRequest: FETCH_COLOR_DETAIL_WITHOUT_ID_REQUEST1,
        responseTypeSuccess: FETCH_COLOR_DETAIL_WITHOUT_ID_SUCCESS1,
        responseTypeFailure: FETCH_COLOR_DETAIL_WITHOUT_ID_FAILURE1
    };
    return axiosCall(config);
};
